import {Injectable, signal} from '@angular/core';
import {UserListItem} from "@app/_models/api";
import {TableOptionsService} from "@app/_services/table-options.service";

@Injectable({
    providedIn: 'root'
})
export class UsersService extends TableOptionsService<UserListItem> {
    readonly customerUserCount = signal(0);
    readonly maxNumberOfUsers = signal(0);

    constructor() {
        super();
    }

    setUserCounts(customerUserCount: number, maxNumberOfUsers: number) {
        this.customerUserCount.set(customerUserCount);
        this.maxNumberOfUsers.set(maxNumberOfUsers);
    }

    public override matches(element: UserListItem, term: string) {
        return (
            element.fullName?.toLowerCase().includes(term.toLowerCase()) ||
            element.email?.toLowerCase().includes(term.toLowerCase())
        );
    }
}
